export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
		};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "chipsInview";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			// if (
			// 	"IntersectionObserver" in window &&
			// 	!document.body.classList.contains("watch-iv")
			// ) {
			// 	document.body.classList.add("watch-iv");
			// }

			const scopeThis = this;
			let observer = new IntersectionObserver(
				(entries, observer) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							scopeThis.$el.classList.add("vis");
							observer.unobserve(entry.target);
						}
					});
				},
				{ rootMargin: "0px" }
			);

			observer.observe(this.$el);
		}
	}
}
